// extracted by mini-css-extract-plugin
export default {"table":"tender-confirm-screen_table__uqS7u","deleteButton":"tender-confirm-screen_deleteButton__-3lag"};